import { render, staticRenderFns } from "./InvoiceControl.vue?vue&type=template&id=a20f2afa"
import script from "./InvoiceControl.vue?vue&type=script&lang=js"
export * from "./InvoiceControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports